import { getProducts } from '../services/api/products'
import Api from '../services/api/api'
import Apiv3 from '../services/api/apiv3'

export default class Products {
  constructor() {
    this.products = []
    this.product = null
    this.total = 0
    this.lastPage = 0
    this.page = 0
    this.tabela_preco = null
    this._subscribers = []
  }

  subscribe(func) {
    this._subscribers.push(func)
  }

  unsubscribe(func) {
    this._subscribers = this._subscribers.filter((f) => f !== func)
  }

  notify() {
    const products = {
      products: this.products,
      product: this.product,
      total: this.total,
      lastPage: this.lastPage,
      page: this.page,
    }
    this._subscribers.forEach((func) => func(products))
  }

  priceByQty = (qty) => {
    if (qty > 0 && qty < 10) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_1 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_1).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 9 && qty < 30) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_10 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_10).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 29 && qty < 50) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_30 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_30).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 49 && qty < 100) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_50 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_50).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 99 && qty < 200) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_100 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_100).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 199 && qty < 300) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_200 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_200).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 299 && qty < 500) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_300 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_300).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 499 && qty < 1000) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_500 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_500).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 999 && qty < 2000) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_1000 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_1000).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 1999 && qty < 3000) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_2000 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_2000).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 2999 && qty < 5000) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_3000 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_3000).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    } else if (qty > 4999) {
      this.product.valor_total = parseFloat(this.product.tabela_custo.qtd_5000 * qty).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
      this.product.valor_unitario = parseFloat(this.product.tabela_custo.qtd_5000).toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      })
    }
  }

  async all(
    loja_id,
    search = '',
    numItens = 5,
    offSet = 0,
    page = 1,
    category = null,
    subcategory = null,
    except = null,
    offers = null
  ) {
    try {
      let resp = await getProducts(loja_id, search, numItens, offSet, page, category, subcategory, except, offers)
      this.products = resp.data.data
      this.total = resp.data.total
      this.lastPage = resp.data.lastPage
      this.page = resp.data.currentPage
      this.notify()
      return resp.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  async show(id, loja_id, sku = null, qty = null) {
    try {
      const resp = await Apiv3.get(`/produto/${id}`, { params: { loja_id, sku } })
      this.product = resp.data
      //this.product.valor_unitario = parseFloat(resp.data.valor_unitario);
      //this.product.desconto_percentual = this.getDesconto(resp.data.oferta, parseFloat(resp.data.quantidade_padrao));
      //this.product.valor_desconto = (this.product.valor_unitario - (this.product.valor_unitario * this.product.desconto_percentual/100)).toFixed(2);
      //this.product.valor_total = parseFloat(resp.data.valor_unitario * parseFloat(resp.data.quantidade_padrao));
      //this.product.valor_total = parseFloat(this.product.valor_desconto * parseFloat(resp.data.quantidade_padrao));

      //this.priceByQty(parseFloat(qty || this.product.quantidade_padrao) || 500);
      this.notify()
    } catch (error) {
      console.log(error)
    }
  }

  getDesconto(ofertas, quantidade) {
    const oferta = ofertas.filter((item) => {
      return item.quantidade <= quantidade
    })

    return oferta.length > 0 ? oferta[oferta.length - 1].desconto_percentual : 0
  }

  async updateValues(id, loja_id, quantidade, gravacao_id) {
    try {
      const resp = await Apiv3.get(`/produto/${id}/price`, { params: { loja_id, quantidade, gravacao_id } })

      this.product = {...this.product, ...resp.data};
      this.notify()
    } catch (error) {
      console.log(error)
    }
  }
}
